export enum AppType {
  Browser = 'BROWSER',
  Capacitor = 'CAPACITOR',
  Pwa = 'PWA',
}
